module.exports = __webpack_public_path__ + "img/payment_pc_12.3933112a.png";